import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../../services/login.service';
import { ConsultaSolicitacoesService } from '../../../../services/consulta-solicitacoes.service';
import { PaginaErroComponent } from '../pagina-erro/pagina-erro.component';

@Component({
  selector: 'ngx-altera-status-interno',
  templateUrl: './altera-status-interno.component.html',
  styleUrls: ['./altera-status-interno.component.scss']
})
export class AlteraStatusInternoComponent implements OnInit {

  dados
  formulario
  usuarioLogado
  selectStatus = ['Pendente', 'Executando', 'Atendido']

  constructor(@Inject(MAT_DIALOG_DATA) data,
    private fb: FormBuilder,
    private loginService: LoginService,
    private ConsultaSolicitacoesService: ConsultaSolicitacoesService,
    private dialogRef: MatDialogRef<AlteraStatusInternoComponent>,
    private dialog: MatDialog) {
    this.dados = data
    
    if(this.dados.StatusAtual == 'Pendente'){
      this.selectStatus = ['Pendente', 'Executando', 'Atendido']
    }
    
    this.formulario = this.fb.group({
      idTarefa: this.dados.idTarefa,
      idNovoUsuarioResponsavel: this.dados.idNovoUsuarioResponsavel,
      NovoStatus: this.dados.StatusAtual,
      VBAlteraStatus: this.dados.VBAlteraStatus,
      VBAlteraResponsavel: this.dados.VBAlteraResponsavel,
      DescricaoSolucao: "",
      idCliente: 0
    })
  }

  ngOnInit(): void {
    this.usuarioLogado = this.loginService.getUsuarioDadosCompletos()
    
  }

  gravar(){

    if(this.formulario.value.idNovoUsuarioResponsavel == this.usuarioLogado.Id){
      this.ConsultaSolicitacoesService.setAlteraStatusResposanvel(this.formulario.value)
      .then(response => {
        if(response){
        this.dialogRef.close(this.formulario.value.NovoStatus)
          this.PaginaErro(`Status do atendimento alterado para: ${this.formulario.value.NovoStatus}`, 'interno')
        }
      }).catch(err => {
        this.dialogRef.close()
        this.PaginaErro(err, 'erro')
      })
    }
    else{
      this.dialogRef.close()
      this.PaginaErro('O usuário precisar ser o responsável pela solicitação', 'interno')
    }
  }

  public PaginaErro(mensagem, tipo) {
  
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.data = {
        mensagem: mensagem,
        tipo: tipo
      }
  
      this.dialog.open(PaginaErroComponent, dialogConfig)
    }

}
